
import React, { useEffect, useState } from 'react';
import {
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
} from '@ionic/react';
import { car } from 'ionicons/icons';
import { getProperty, getPropertySecurityFeatures } from '../utilities/Storage';
import ActionButton from '../components/ActionButton';
import moment from 'moment';
import {Toolbar} from "./Toolbar";

export default function Property({history, match}) {

  const { id } = match.params;

  const [property, setProperty] = useState();
  const [securityFeatures, setSecurityFeatures] = useState();

  useEffect(() => {
    getProperty(id).then(property => setProperty(property));
    getPropertySecurityFeatures(id).then(securityFeatures => setSecurityFeatures(securityFeatures));
  }, []);

  const navigate = () => {
    window.open(`geo:${property.address.latitude},${property.address.longitude}?q=${property.address.latitude},${property.address.longitude}(test)`, '_system');
  }

  if (!property) {
    return null;
  }

  const address = [
    property.address.line1,
    property.address.line2,
    property.address.line3,
    property.address.town,
    property.address.county,
    property.address.postcode,
  ].filter(Boolean);

  const actionButtons = [
    { label: 'navigate', icon: car, onClick: navigate },
  ];

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title={property.name} backButtonHref="/" />
      </IonHeader>
      <IonContent>
        <IonList lines="full">
          <IonItem>
            <IonLabel>
              id / ref
              <p>{property.id} / {property.tabspropref}</p>
            </IonLabel>
          </IonItem>          
          <IonItem>
            <IonLabel>
              address
              <p>{address.map((line, i) => 
              <React.Fragment key={'address' + i}>{line}<br /></React.Fragment>  
              )}</p>
            </IonLabel>
          </IonItem>
          {securityFeatures && securityFeatures.filter(
            sf => moment().isBetween(sf.fromdate, sf.todate, 'day', '[]')
          ).map(sf => 
          <IonItem key={'sf' + sf.id}>
            <IonLabel className="ion-text-wrap">
              {sf.securityfeature.name.toLowerCase()}
              <p>{sf.code}{sf.notes ? (' - ' + sf.notes) : ''}</p>
            </IonLabel>
          </IonItem>
          )}
        </IonList>
        <IonGrid>
          <IonRow>
            {actionButtons.map((ab, i) => 
            <ActionButton key={i} {...ab} />       
            )}
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
}